import { useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import enLocale from "date-fns/locale/en-US";
import {
    MuiPickersUtilsProvider,
    KeyboardDateTimePicker,
} from '@material-ui/pickers';
import {
    CalendarToday
} from '@material-ui/icons';
import ClearIcon from "@material-ui/icons/Clear";
import { IconButton } from "@material-ui/core";

export default function DateTimePickerField({
    id,
    name,
    label,
    value,
    onChange,
}) {
    const [isOpen, setIsOpen] = useState(false);
    const dtValue = value ? new Date(value) : value;

    const handleDateChange = (date) => {
        let dt = date ? new Date(date).getTime() : null;
        onChange && onChange({ target: { id, value: dt } });
        setIsOpen(false);
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={enLocale}>
            <KeyboardDateTimePicker
                id={id}
                name={name}
                label={label}
                value={dtValue}
                onChange={handleDateChange}
                format="MMM-dd-yyyy HH:mm"
                KeyboardButtonProps={{
                    'id': 'calendar-button-icon',
                    'aria-label': 'change date',
                    onFocus: () => setIsOpen(!dtValue)
                }}
                PopoverProps={{
                    disableRestoreFocus: true,
                    onClose: () => setIsOpen(false),
                }}
                open={isOpen}
                keyboardIcon={<CalendarToday color="primary" />}
                InputProps={{
                    onFocus: () => setIsOpen(!dtValue),
                    startAdornment:
                        dtValue ?
                            <IconButton onClick={() => handleDateChange()} disabled={!value} style={{ order: 1 }}>
                                <ClearIcon color="disabled" fontSize="small" />
                            </IconButton>
                            :
                            null
                }}
                InputAdornmentProps={{
                    position: "end",
                    style: { order: 2, marginLeft: 5, marginTop: -1 }
                }}
            />
        </MuiPickersUtilsProvider>
    );
}